import type { JSX } from 'react';

import AppIcon from '../../wrapper/AppIcon';

export const HeaderIcon = (props: { type: string }): JSX.Element => (
    <AppIcon type={props.type} size={'large'} className={'margin-right-5'} />
);
